import { render, staticRenderFns } from "./BulkRevenuesTool.vue?vue&type=template&id=21ac0a34"
import script from "./BulkRevenuesTool.vue?vue&type=script&lang=js"
export * from "./BulkRevenuesTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports